var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M14.406 9.421v1.032a.517.517 0 01-.516.515h-2.922v2.922a.517.517 0 01-.515.516H9.42a.517.517 0 01-.515-.516v-2.922H5.984a.517.517 0 01-.515-.515V9.42c0-.283.232-.515.515-.515h2.922V5.984c0-.283.232-.515.515-.515h1.032c.283 0 .515.232.515.515v2.922h2.922c.284 0 .516.232.516.515zm8.443 12.456l-.972.972a.517.517 0 01-.73 0l-5.216-5.217a.506.506 0 01-.15-.365V16.7a8.918 8.918 0 01-5.844 2.174C5 18.874 1 14.874 1 9.937 1 5 5 1 9.937 1c4.937 0 8.937 4 8.937 8.937 0 2.234-.82 4.275-2.174 5.844h.567c.138 0 .267.055.365.15l5.217 5.216a.517.517 0 010 .73zm-6.037-11.94c0-3.798-3.077-6.875-6.875-6.875S3.062 6.14 3.062 9.937s3.077 6.875 6.875 6.875 6.875-3.077 6.875-6.875z"
  }))));
}

export default SvgSearchPlus;